export default __webpack_public_path__ + "static/media/happy.430a82e3.svg";